<template>
  <section class="lead-follow-up-strip ui-card-progress" :class="[stateClass, `ui-card-progress--${stateCode}`]" aria-label="Follow-up automation">
    <div class="lead-follow-up-strip__heading ui-card-progress__heading">
      <strong>
        <i class="pi pi-bolt" aria-hidden="true" />
        <AppTableText :text="displayName" />
      </strong>
      <span>{{ processed }} of {{ total }}</span>
    </div>
    <LeadFollowUpProgress
      :progress="followUp.progress"
      :state="stateCode"
      :failed="followUp.has_failed_action"
      :next-status="nextStatus"
    />
  </section>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import LeadFollowUpProgress from '@/views/crm/task-tracker/LeadFollowUpProgress.vue'
import { processedCount } from '@/views/crm/task-tracker/leadFollowUpProgress'

export default {
  name: 'LeadFollowUpStrip',
  components: {
    AppTableText,
    LeadFollowUpProgress
  },
  props: {
    followUp: {
      type: Object,
      required: true
    },
    now: {
      type: Number,
      default: () => Date.now()
    }
  },
  computed: {
    displayName() {
      const displayState = this.followUp.display_state || {}
      return displayState.name || 'Auto follow-up'
    },
    stateCode() {
      const displayState = this.followUp.display_state || {}
      return displayState.code || 'active'
    },
    stateClass() {
      return `lead-follow-up-strip--${this.stateCode}`
    },
    processed() {
      return processedCount(this.followUp.progress)
    },
    total() {
      return Number(this.followUp.progress && this.followUp.progress.total) || 0
    },
    nextAction() {
      return this.followUp.next_action || {}
    },
    nextStatus() {
      const status = this.nextAction.status
      return typeof status === 'string' ? status : (status && status.code) || ''
    }
  }
}
</script>
